import $ from 'jquery';
import slick from 'slick-carousel';

$('.rooms-carousel').slick({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: true,
    responsive: true,
});

$('.cards-carousel, .promo-cards-carousel').on('init reInit', function (event, slick, direction) {

    // check to see if there are four or less slides
    const emoryCardsCarousel = document.querySelector('.cards-carousel__wrapper');
    if (slick.slideCount < 4 && document.body.clientWidth > 991) {
        // remove arrows
        $(this).closest('.cards-carousel__wrapper').find('.slick-arrow').hide();

        emoryCardsCarousel.classList.add('js-center-align-override');
    }

    slick.$slider[0].querySelectorAll('.slick-slide').forEach((slide, i) => {
        if (i % 2 !== 0) slide.classList.add('large');
    })

});

$('.cards-carousel--surrenne').on('init', function (event, slick, direction) {

    // check to see if there are four or less slides
    if (!($('.cards-carousel .slick-slide').length > 4) && (screen.width > 991)) {
        // remove arrows
        $('.cards-carousel__wrapper--surrenne .cards-carousel__controlsWrapper').hide();

    }
});

function isSlickWrapping(e, slick, currentSlide, nextSlide) {

    const slideCountIsOdd = (slick.slideCount % 2)
    const movementIsWrapping = (Math.abs(currentSlide - nextSlide) > 1)

    if (slideCountIsOdd && movementIsWrapping) slick.wrapped = true
}

$(".cards-carousel, .promo-cards-carousel").on("beforeChange reInit", isSlickWrapping);


$(".cards-carousel, .promo-cards-carousel").on("breakpoint", function (event, slick, breakpoint) {
    slick.$slider[0].querySelectorAll('.slick-slide').forEach((slide, i) => {
        if (i % 2 !== 0) slide.classList.add('large');
    })
});

function ifWrappedToggleClass(e, slick) {
    if (slick.wrapped == true) {
        slick.$slider[0].querySelectorAll('.slick-slide').forEach((slide) => {
            slide.classList.toggle('large')
        })
        slick.wrapped = false
    }
}

$(".cards-carousel, .promo-cards-carousel").on("afterChange", ifWrappedToggleClass);


$('.cards-carousel').each(function () {

    var slider = $(this);

    slider.slick({
        dots: false,
        infinite: true,
        //appendArrows: ".cards-carousel__arrowsContainer",
        arrows: true,
        centerMode: true,
        centerPadding: '160px',
        slidesToShow: slider.hasClass('cards-carousel--surrenne') ? 5 : 3,
        variableWidth: true,
        cssEase: 'ease-in-out',
        initialSlide: 1,
        touchThreshold: 50,
        prevArrow: slider.closest('.js-carousel-wrapper').find('.slick-prev'),
        nextArrow: slider.closest('.js-carousel-wrapper').find('.slick-next'),

        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 769,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    initialSlide: 0

                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]

    });

})


$('.promo-cards-carousel').each(function () {

    var slider = $(this);

    slider.slick({
        dots: false,
        infinite: true,
        arrows: false,
        draggable: true,
        autoplay: false,
        centerPadding: '160px',
        centerMode: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        unslick: true,
        touchThreshold: 100,

        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '40px',
                    initialSlide: 1
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '40px',
                    initialSlide: 1
                }
            }
        ]
    });


});
